<template>
    <router-view v-slot="{ Component }"   :accusedPerson = "accusedPerson" :setAccusedPerson = "setAccusedPerson"  :setName="setName" :personName="personName" >
      <transition :name="'slide-fade'">
        <component :is="Component" />
      </transition>
    </router-view>
</template>
<script>
export default {
  data(){
    return {
        personName:"",
        accusedPerson: "",
    }
  },
  methods:{
    setAccusedPerson(name){
      this.accusedPerson = name;
    },
    setName(name){
      this.personName = name;
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

#app {
  font-family: 'Poppins';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding:0.5%;
}
</style>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.01s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>